import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { finalize } from 'rxjs';
import { MemberApiService } from 'src/app/core/services/api/member-api.service';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';

@Component({
  selector: 'app-approval-emails',
  templateUrl: './approval-emails.component.html',
  styleUrls: ['./approval-emails.component.scss'],
})
export class ApprovalEmailsComponent implements OnInit, OnChanges {
  @Input() memberId!: number;
  @Input() approvalEmails: string[] = [];

  emails: string[] = [];
  newEmail = '';
  isEditing = false;
  isSaving = false;

  constructor(
    private memberApi: MemberApiService,
    private notificationService: NotificationsService,
    private errHandle: ErrorHandlingService
  ) {}

  ngOnInit(): void {
    this.emails = [...(this.approvalEmails || [])];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['approvalEmails']) {
      this.emails = [...(this.approvalEmails || [])];
    }
  }

  addEmail(): void {
    const email = this.newEmail.trim().toLowerCase();
    if (!email) return;
    if (!this.isValidEmail(email)) {
      this.notificationService.error('Error', 'Please enter a valid email address');
      return;
    }
    if (this.emails.includes(email)) {
      this.notificationService.error('Error', 'This email is already in the list');
      return;
    }
    this.emails.push(email);
    this.newEmail = '';
  }

  removeEmail(index: number): void {
    this.emails.splice(index, 1);
  }

  save(): void {
    if (!this.memberId) return;
    this.isSaving = true;
    this.memberApi
      .updateApprovalEmails(this.memberId, this.emails)
      .pipe(finalize(() => (this.isSaving = false)))
      .subscribe({
        next: (res) => {
          this.notificationService.success('Success', res?.message || 'Approval emails updated');
          this.isEditing = false;
        },
        error: (err) => this.errHandle.errorHandling(err),
      });
  }

  cancel(): void {
    this.emails = [...(this.approvalEmails || [])];
    this.newEmail = '';
    this.isEditing = false;
  }

  private isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
}
